var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95833 13.0416H3.06667L9.89479 6.21346L8.78646 5.10513L1.95833 11.9333V13.0416ZM13.2792 5.06554L9.91458 1.74054L11.0229 0.63221C11.3264 0.328738 11.6993 0.177002 12.1415 0.177002C12.5838 0.177002 12.9564 0.328738 13.2594 0.63221L14.3677 1.74054C14.6712 2.04402 14.8295 2.41029 14.8427 2.83938C14.8559 3.26846 14.7108 3.63447 14.4073 3.93742L13.2792 5.06554ZM12.1312 6.23325L3.73958 14.6249H0.375V11.2603L8.76667 2.86867L12.1312 6.23325ZM9.34062 5.65929L8.78646 5.10513L9.89479 6.21346L9.34062 5.65929Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreEditIcon);
export default __webpack_public_path__ + "static/media/moreEditIcon.2e42f43d48947fe7556ee276f6ad20b2.svg";
export { ForwardRef as ReactComponent };